import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        works: null,
        homeContent: null,
        searchResults: null,
        actualLinks: null
    },
    mutations: {
        setWorksFromAPI: (state, payload) => {
            state.works = payload
        },
        setHomeContentFromAPI: (state, payload) => {
            state.homeContent = payload
        },
        setSearchResults: (state, payload) => {
            state.searchResults = payload
        },
        setActualLinks: (state, payload) => {
            state.actualLinks = payload
        }
    },
    actions: {
        GET_WORKS_FROM_API: ({commit}) => {

            axios.get(process.env.VUE_APP_API_URL + '/works/').then(response => {
                commit('setWorksFromAPI', response.data)
            })
        },
        GET_ACTUALLINKS_FROM_API: ({commit}) => {

            axios.get(process.env.VUE_APP_API_URL + '/actuals/').then(response => {
                commit('setActualLinks', response.data)
            })
        },
        GET_HOMECONTENT_FROM_API: ({commit}) => {

            axios.get(process.env.VUE_APP_API_URL + '/home/').then(response => {
                commit('setHomeContentFromAPI', response.data)
            })
        },
        GET_SEARCH_RESULTS_FROM_API: ({commit}, payload) => {
            let resultsByDescription = []
            let resultsByTitle = []

            axios.get(process.env.VUE_APP_API_URL + '/works/?description_contains=' + payload).then(responseByDescription => {
                resultsByDescription = responseByDescription.data
                axios.get(process.env.VUE_APP_API_URL + '/works/?title_contains=' + payload).then(responseByTitle => {
                    resultsByTitle = responseByTitle.data
                    var combinedResults = _.concat(resultsByTitle, resultsByDescription)
                    var unDupedResults = _.uniq(combinedResults)
                    commit('setSearchResults', unDupedResults)
                })
            })
        }
    },
    modules: {}
})
